import {createStore} from 'vuex';
import authModule from './auth';
import uiModule from './ui';
import { vuexLocal } from "@/store/vuex-persist";

export default createStore({
    modules: {
        auth: authModule,
        ui: uiModule
    },
    plugins: [vuexLocal.plugin]
});
